import { toastr } from "react-redux-toastr";
import React, { PureComponent } from "react";
import Images from "../../Assets/Images";
import Api from "../../Services/Api";
import { Dropdown } from 'react-bootstrap';
export default class TextNarrative extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
          emailId: "",
          message: "",
          projectHomeFlag: false,
          openPdfTitlePopup: false,
          title: "",
          showAddToCart: false,
          visible: false,
          textNarrative: this.props.chartInputs,
          enablebluetexticon:false,
        };
        this._exporterBarChart = React.createRef();

      }
      temp=(e)=>{
        console.log("temp")
        this.setState({
          ...this.state,
          textNarrative :e.target.value,
          count : 1
        })
        this.props.chartInputs["textNarrative"]=e.target.value
      }
      temp1  (val){
        this.setState({
          ...this.state,
          textNarrative :val,
          count : 1
        })
      }
      saveDescription  = async (widgetId,flag) => {
        try {
          const requestParams = {
            TextNarrative : this.state.textNarrative,
            WidgetId: widgetId,
          };
          this.setState({ ...this.state, loader: true });
          let response = await Api.widgetTextNarrative(requestParams);
          if (response.status === 200) {
            this.setState({ ...this.state, loader: false });
            flag===false&&
            toastr.success(response.message)
            this.props.refreshTextNarative&&this.props.refreshTextNarative(this.state.textNarrative,widgetId);
          } else {
            this.setState({ ...this.state, loader: false });
            toastr.error(response.message);
          }
        } catch (error) {
          console.error(error);
          this.setState({ ...this.state, loader: false });
        }
      }
      handletextnarrativeicon=(tempchartData)=>{
        const isenable=tempchartData.textNarrative?true:false;
        this.setState({
          enablebluetexticon:isenable
        })
      }
      render() {
        const chartData = this.props.chartInputs ? this.props.chartInputs : {};
        this.handletextnarrativeicon(chartData)
        if(this.state.count == 0){
            this.temp1(chartData.textNarrative);
        }
      return (
        <li>
          <Dropdown
            menuAlign="right"
            title="Text Narrative"
            id="dropdown-menu-align-right"
          >
            <Dropdown.Toggle>
              <a>
                {this.state.enablebluetexticon ? (
                  <img src={Images.BLUETEXT} alt="Share" width="14" />
                ) : (
                  <img src={Images.TEXT} alt="Share" width="14" />
                )}
              </a>
            </Dropdown.Toggle>
            <Dropdown.Menu className="filterList emailBox">
              <div className="filterBox">
                <div className="dateRange">
                  <div className="dateCont">
                    <h6>Text Narrative</h6>
                    <textarea
                     value={this.state.textNarrative.textNarrative}
                     onChange={(e)=>this.temp(e)}
                      autoComplete="off"
                      disabled={this.props.isFreezeDS}
                      // onBlur={() => this.saveDescription(chartData.widgetId,true)}
                    ></textarea>
                    {this.props.isFreezeDS ? (
                      ""
                    ) : (
                      <Dropdown.Item
                        as="button"
                        onClick={() => this.saveDescription(chartData.widgetId,false)}
                      >
                        Submit
                      </Dropdown.Item>
                    )}
                  </div>
                </div>
              </div>
            </Dropdown.Menu>
          </Dropdown>
        </li>
      );}
      
}